module.exports = __webpack_public_path__ + "static/media/11B.f7f50cf7.jpg";